<template>
	<BaseLayout background-color-class="bg-color-white" :content-full-height="true">
		<template #header>
			<HeaderBasic :cancel-modal="cancelModal">
				<p class="ml-300 mt-0 delta">{{ pageTitle }}</p>
			</HeaderBasic>
		</template>

		<div class="container pt-200 pt-0-smo">
			<div class="grid-md gutters-300-md">
				<div class="col-8-lg col-offset-2-lg col-10-md col-offset-1-md">
					<router-view v-slot="{ Component }">
						<TransitionSubpage>
							<component :is="Component" />
						</TransitionSubpage>
					</router-view>
				</div>
			</div>
		</div>
	</BaseLayout>
</template>

<script setup lang="ts">
import CancelConfirmationModal from '@components/header/cancel-confirmation-modal.vue';
import { computed } from 'vue';
import { CurrentModal } from 'types/modal';
import HeaderBasic from '@components/header/header-basic.vue';
import TransitionSubpage from '@components/layout/transition-subpage.vue';
import { useHead } from '@unhead/vue';
import { useRoute } from 'vue-router';

const route = useRoute();

const cancelModal = computed((): CurrentModal | null =>
	route.name !== 'micro-feedback-success' && route.name !== 'hpi-survey-success'
		? { modal: CancelConfirmationModal }
		: null
);

const pageTitle = computed((): string =>
	route.name === 'micro-feedback-success' ? 'Thank you for your input' : 'Share your feedback'
);

function setup(): void {
	useHead({
		title: pageTitle.value,
		meta: [{ property: 'og:title', content: pageTitle.value }]
	});
}

setup();
</script>
